// extracted by mini-css-extract-plugin
export var quantityInput = "_mx-0";